"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Italic = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "italic" },
            react_1.default.createElement("path", { id: "Icon", d: "M19 5C19.5523 5 20 4.55228 20 4C20 3.44772 19.5523 3 19 3V5ZM10 3C9.44772 3 9 3.44772 9 4C9 4.55228 9.44772 5 10 5V3ZM14 21C14.5523 21 15 20.5523 15 20C15 19.4477 14.5523 19 14 19V21ZM5 19C4.44772 19 4 19.4477 4 20C4 20.5523 4.44772 21 5 21V19ZM15.9363 4.35112C16.1302 3.834 15.8682 3.25759 15.3511 3.06367C14.834 2.86975 14.2576 3.13176 14.0637 3.64888L15.9363 4.35112ZM8.06367 19.6489C7.86975 20.166 8.13176 20.7424 8.64888 20.9363C9.166 21.1302 9.74241 20.8682 9.93633 20.3511L8.06367 19.6489ZM19 3H10V5H19V3ZM14 19H5V21H14V19ZM14.0637 3.64888L8.06367 19.6489L9.93633 20.3511L15.9363 4.35112L14.0637 3.64888Z" }))));
};
exports.default = Italic;
